<template>
  <div id="PreviewSimulationModal">
    <v-dialog v-model="viewSimulationLocal" max-width="460">
      <v-card>
        <v-card-title class="text-h6">
          <v-icon color="primary" class="mr-2">mdi-check-circle</v-icon>
          Simulation finished
        </v-card-title>
        <v-card-text>
          The results (maps, video, spectra) are saved. Open them now or keep editing the
          simulation; you can also find them later under the simulation's productions.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="setViewSimulation(false)">Keep editing</v-btn>
          <v-btn color="primary" @click="openResults">View results</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "PreviewSimulationModal",
  props: {
    is3d: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions("simulator", ["setViewSimulation", "openPlotOptions"]),
    openResults() {
      this.setViewSimulation(false);
      this.$router.push((this.is3d ? "/simulations3d/" : "/simulations/") + this.id);
    }
  },
  watch: {},
  computed: {
    ...mapGetters("simulator", [
      "view_simulation",
      "id",
      "scene_simulation",
      "scene_design",
      "movie",
      "id",
      "author"
    ]),
    movieLocal: function() {
      // videoName vem do módulo 2D como "./storage/users/<autor>/<simulação>/<arquivo>.mp4"
      const path = String(this.movie || "").replace(/^\.?\//, "/");
      return encodeURI(`${process.env.VUE_APP_SIMULATOR_LOCATION}${path}`);
    },
    viewSimulationLocal: {
      get() {
        return this.view_simulation;
      },
      set(val) {
        this.setViewSimulation(val);
      }
    }
  },
  mounted: function() {}
};
</script>
